import { container } from "tsyringe";
import ApiService from "@/app/infrastructures/services/ApiService";
import { PrintReceiptApiRepository } from "@/app/infrastructures/repositories/api/PrintReceiptApiRepository";
import { PrintReceiptMapper } from "@/data/persistences/mappers/PrintReceiptMapper";
import { PrintReceiptEndpoint } from "@/app/infrastructures/endpoints/PrintReceiptEndpoint";
import { PrintReceiptPresenter } from "@/app/ui/presenters/PrintReceiptPresenter";

export class PrintReceiptComponent {
  public static init() {
    container.register<PrintReceiptApiRepository>(PrintReceiptApiRepository, {
      useFactory: (d) => {
        return new PrintReceiptApiRepository(
          d.resolve(ApiService),
          d.resolve(PrintReceiptMapper),
          d.resolve(PrintReceiptEndpoint)
        );
      }
    });
    container.register<PrintReceiptMapper>(PrintReceiptMapper, {
      useClass: PrintReceiptMapper
    });
    container.register<PrintReceiptPresenter>(PrintReceiptPresenter, {
      useFactory: (d) => {
        return new PrintReceiptPresenter(d.resolve(PrintReceiptApiRepository));
      }
    });
  }
}
